(ns portal.v2-user-table.queries
  (:require [cljs-bean.core :refer [->clj]]
            [common.queries :refer [invalidate-queries prevent-client-error-retries]]
            [common.queries.http :as qhttp]
            [re-frame.core :as rf]))

(defn v2-users-query []
  #js {:queryKey #js ["v2-users"]
       :queryFn (fn [_ctx]
                  (qhttp/get (qhttp/render :api/auth-v2-users {}
                                           {:pagesize 1000})))
       :retry prevent-client-error-retries
       :staleTime (* 5 60 1000)})

(defn user-grants-query [{:keys [useraccount-id]}]
  #js {:queryKey #js ["v2-user-grants" useraccount-id]
       :queryFn (fn [_ctx]
                  (qhttp/get (qhttp/render :api/auth-v2-grants {}
                                           {:useraccount-id useraccount-id})))
       :enabled (some? useraccount-id)
       :staleTime (* 60 1000)})

(defn v2-roles-query []
  #js {:queryKey #js ["v2-roles"]
       :queryFn (fn [_ctx]
                  (qhttp/get (qhttp/render :api/auth-v2-roles {})))
       :staleTime (* 5 60 1000)})

(defn create-grant-mutation []
  #js {:mutationKey #js ["v2-create-grant"]
       :mutationFn (fn [grant-data]
                     (qhttp/post (qhttp/render :api/auth-v2-grants {})
                                 {:body grant-data}))
       :onSuccess (fn [_response]
                    (invalidate-queries {:queryKey ["v2-users"]})
                    (invalidate-queries {:queryKey ["v2-user-grants"]})
                    (rf/dispatch [:response-handler/handle-response
                                  {:entity-name "Grant"
                                   :type :success
                                   :message "Successfully added grant"}]))
       :onError (fn [^js response]
                  (rf/dispatch [:response-handler/handle-response
                                {:entity-name "Grant"
                                 :type :error
                                 :message "Failed to add grant"
                                 :response (->clj response)}]))})

(defn create-user-mutation []
  #js {:mutationKey #js ["v2-create-user"]
       :mutationFn (fn [user-data]
                     (qhttp/post (qhttp/render :api/auth-v2-users {})
                                 {:body user-data}))
       :onSuccess (fn [_response]
                    (invalidate-queries {:queryKey ["v2-users"]})
                    (rf/dispatch [:ocp/close])
                    (rf/dispatch [:response-handler/handle-response
                                  {:entity-name "User"
                                   :type :success
                                   :message "Successfully created user"}]))
       :onError (fn [^js response]
                  (rf/dispatch [:response-handler/handle-response
                                {:entity-name "User"
                                 :type :error
                                 :message "Failed to create user"
                                 :response (->clj response)}]))})

(defn wpp-os-check-email [email]
  (qhttp/get (qhttp/render :api/wpp-os-users {}
                           {:search email :limit 1})))

(defn delete-grant-mutation []
  #js {:mutationKey #js ["delete-grant"]
       :mutationFn (fn [grant-id]
                     (qhttp/delete (qhttp/render :api/auth-v2-grant {:grant-id grant-id})))
       :onSuccess (fn [_response]
                    (invalidate-queries {:queryKey ["v2-users"]})
                    (invalidate-queries {:queryKey ["v2-user-grants"]})
                    (rf/dispatch [:response-handler/handle-response
                                  {:entity-name "Grant"
                                   :type :success
                                   :message "Successfully removed grant"}]))
       :onError (fn [^js response]
                  (rf/dispatch [:response-handler/handle-response
                                {:entity-name "Grant"
                                 :type :error
                                 :message "Failed to remove grant"
                                 :response (->clj response)}]))})
